/* La Grue Jaune ā€“ onglets de la section Ā« LGJ ā€“ Coups de cÅ“ur Ā» */
(function () {
  if (window.__lgjLoaded) return;
  window.__lgjLoaded = true;

  function initTabs(root) {
    if (!root || root.dataset.lgjReady) return;
    root.dataset.lgjReady = '1';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;

    function select(tab) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
    }
    root.__lgjSelect = select;

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab); });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        if (e.key === 'Home') next = tabs[0];
        if (e.key === 'End') next = tabs[tabs.length - 1];
        if (next) { e.preventDefault(); next.focus(); select(next); }
      });
    });
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-lgj-tabs]'), initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Ć‰diteur de thĆØme Shopify : rĆ©initialise aprĆØs modification
     et affiche lā€™onglet du bloc sĆ©lectionnĆ© dans la barre latĆ©rale. */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var tab = document.getElementById('lgj-tab-' + e.detail.blockId);
    if (!tab) return;
    var root = tab.closest('[data-lgj-tabs]');
    if (root && root.__lgjSelect) root.__lgjSelect(tab);
  });
})();